module.exports = __webpack_public_path__ + "img/logo_MIPIH.67a5927d.png";